<mat-form-field
  appearance="outline"
  [floatLabel]="floatLabel"
>
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <textarea
    matInput
    [rows]="rows"
    [value]="value"
    [formControl]="control"
    [placeholder]="placeholder"
    (ngModelChange)="onInputChange($event)"
  ></textarea>
  <mat-error>
    <ng-content select="[error]"></ng-content>
  </mat-error>
</mat-form-field>
